import script from "./menu_item.vue?vue&type=script&lang=ts&setup=true"
export * from "./menu_item.vue?vue&type=script&lang=ts&setup=true"

import "./menu_item.vue?vue&type=style&index=0&id=ad3febdc&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\kili-operation-page-lite\\kili_admin_view\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad3febdc"]])

export default __exports__